export const getColorByAQI = (aqi) => {
  if (aqi === 2) return "aqi-moderate";
  if (aqi === 3) return "aqi-sensitive";
  if (aqi === 4) return "aqi-unhealthy";
  if (aqi === 5) return "aqi-very-unhealthy";
  if (aqi === 6) return "aqi-hazardous";

  return "aqi-good";
};

export function meteomaticsJsonToGrid(json) {
  let coords = [];

  if (Array.isArray(json.data)) {
    coords = json.data[0]?.coordinates || [];
  } else if (json.data?.coordinates) {
    coords = json.data.coordinates;
  } else {
    return null;
  }

  const lats = [...new Set(coords.map((c) => c.lat))].sort((a, b) => b - a);
  const lons = [...new Set(coords.map((c) => c.lon))].sort((a, b) => a - b);

  const dx = Math.abs(lons[1] - lons[0]);

  const data = [];

  for (let i = 0; i < lats.length; i++) {
    for (let j = 0; j < lons.length; j++) {
      const lat = lats[i];
      const lon = lons[j];
      const match = coords.find((p) => p.lat === lat && p.lon === lon);
      const val = match?.dates?.[0]?.value ?? -9999;
      data.push(val);
    }
  }

  return {
    ncols: lons.length,
    nrows: lats.length,
    xllcorner: lons[0],
    yllcorner: lats.at(-1),
    cellsize: dx,
    nodata: -9999,
    data,
  };
}

export function gridToAsc(grid) {
  const { ncols, nrows, xllcorner, yllcorner, cellsize, nodata, data } = grid;

  const header = [
    `ncols         ${ncols}`,
    `nrows         ${nrows}`,
    `xllcorner     ${xllcorner}`,
    `yllcorner     ${yllcorner}`,
    `cellsize      ${cellsize}`,
    `NODATA_value  ${nodata}`,
  ];

  const body = [];
  for (let i = 0; i < nrows; i++) {
    const row = data.slice(i * ncols, (i + 1) * ncols);
    body.push(row.join(" "));
  }

  return [...header, ...body].join("\n");
}
